import React from 'react';

const Navbar4 = () => {
  return (
    <div className="responsive-box" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="300">
    <h5 className="text-white mb-3" style={{ fontFamily: 'Barlow Condensed' }}>Our Services</h5>
    <ul className="list-unstyled text-white" style={{ fontFamily: 'Barlow Condensed' }}>
      <li className="py-1 border-bottom">
        <a href="/kitchen-renovations" className="text-white text-decoration-none">Kitchen Renovations</a>
      </li> 
      <li className="py-1 border-bottom">
        <a href="/bathroom-renovation" className="text-white text-decoration-none">Bathroom Renovations</a>
      </li>
      <li className="py-1 border-bottom">
        <a href="/basement-renovation" className="text-white text-decoration-none">Basement Renovations</a>
      </li>
      <li className="py-1 border-bottom">
        <a href="/home-renovation" className="text-white text-decoration-none">Home Extensions</a>
      </li>
    </ul>
  </div>
  
  );
};

export default Navbar4;
